const LocationIcon = () => {
  return (
    <svg
      width="20"
      height="30"
      viewBox="0 0 20 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_128_1868)">
        <path
          d="M9.99778 0C4.47596 0 0 4.87687 0 10.8933C0 16.9097 9.99778 29.9952 9.99778 29.9952C9.99778 29.9952 19.9956 16.9097 19.9956 10.8933C19.9956 4.87687 15.524 0 9.99778 0ZM9.99778 15.4708C7.68004 15.4708 5.79659 13.4235 5.79659 10.8933C5.79659 8.36311 7.6756 6.31579 9.99778 6.31579C12.32 6.31579 14.199 8.36311 14.199 10.8933C14.199 13.4235 12.32 15.4708 9.99778 15.4708Z"
          fill="#E75F2B"
        />
      </g>
      <defs>
        <clipPath id="clip0_128_1868">
          <rect width="20" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LocationIcon
